var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalEdit',{attrs:{"editingItem":_vm.item,"onSubmit":_vm.onSubmit,"formSchema":_vm.formSchema,"modalName":_vm.modalName}})
}
var staticRenderFns = []

export { render, staticRenderFns }